export const formatDate = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleDateString("pt-BR");
};

export const timeAgo = (value) => {
  if (!value) return "";
  const diff = Date.now() - new Date(value).getTime();
  const minutes = Math.floor(diff / 60000);
  if (minutes < 1) return "agora mesmo";
  if (minutes < 60) return `há ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `há ${hours}h`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `há ${days} dia${days > 1 ? "s" : ""}`;
  const months = Math.floor(days / 30);
  if (months < 12) return `há ${months} ${months > 1 ? "meses" : "mês"}`;
  const years = Math.floor(months / 12);
  return `há ${years} ano${years > 1 ? "s" : ""}`;
};

export const audienceLabel = (value) => {
  const map = {
    ATACADO: "Atacado",
    VAREJO: "Varejo",
    FOOD_SERVICE: "Food Service",
  };
  return map[value] || value || "-";
};

export const statusLabel = (value) => {
  const map = {
    PENDENTE: "Pendente",
    APROVADO: "Aprovado",
    REJEITADO: "Rejeitado",
    PAUSADO: "Pausado",
    EXPIRADO: "Expirado",
  };
  return map[value] || value || "-";
};

export const statusTone = (value) => {
  if (!value) return "info";
  if (value === "APROVADO") return "success";
  if (value === "PENDENTE") return "warning";
  if (value === "REJEITADO") return "danger";
  if (value === "PAUSADO" || value === "EXPIRADO") return "info";
  return "info";
};

export const onlyDigits = (value = "") => String(value).replace(/\D/g, "");

export const maskCnpj = (value = "") => {
  const digits = onlyDigits(value).slice(0, 14);
  if (digits.length <= 2) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  if (digits.length <= 8)
    return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`;
  if (digits.length <= 12)
    return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(
      5,
      8
    )}/${digits.slice(8)}`;
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(
    5,
    8
  )}/${digits.slice(8, 12)}-${digits.slice(12)}`;
};

export const maskCep = (value = "") => {
  const digits = onlyDigits(value).slice(0, 8);
  return digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
};

const cnpjCheckDigit = (digits) => {
  let weight = digits.length - 7;
  let sum = 0;
  for (let index = 0; index < digits.length; index += 1) {
    sum += Number(digits[index]) * weight;
    weight -= 1;
    if (weight < 2) weight = 9;
  }
  const rest = sum % 11;
  return rest < 2 ? 0 : 11 - rest;
};

export const isValidCnpj = (value = "") => {
  const digits = onlyDigits(value);
  if (digits.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(digits)) return false;
  if (cnpjCheckDigit(digits.slice(0, 12)) !== Number(digits[12])) return false;
  return cnpjCheckDigit(digits.slice(0, 13)) === Number(digits[13]);
};
